import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guarantee } from '../data/content';
export function Guarantee() {
  return <section className="bg-cream py-20 sm:py-24" aria-labelledby="guarantee-title" data-id="element-99" data-mp="1o33u6h0ytshr">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-100" data-mp="222d797tvk6hi">
        <div className="grid items-center gap-8 rounded-[2rem] bg-paper p-8 shadow-soft ring-1 ring-cream-line sm:p-12 md:grid-cols-[auto_1fr] md:gap-12" data-id="element-101" data-mp="1x4l7jrmzng2r">
          <div className="mx-auto flex h-32 w-32 flex-col items-center justify-center rounded-full border border-sage/40 bg-sage-wash text-center" data-id="element-102" data-mp="19fac8poeqdw0">
            <ShieldCheckIcon className="h-7 w-7 text-sage-deep" strokeWidth={1.6} aria-hidden="true" data-id="element-103" data-mp="1j4ai8t1bu9jp" />
            <span className="mt-1 font-display text-3xl leading-none text-petrol" data-id="element-104" data-mp="1edbxnh9b2pan">{guarantee.days}</span>
            <span className="mt-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-sage-deep" data-id="element-105" data-mp="qnpwio9di000">días</span>
          </div>
          <div className="text-center md:text-left" data-id="element-106" data-mp="loda24meyuxy">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-107" data-mp="ozro0as4edzt">Compra con tranquilidad</p>
            <h2 id="guarantee-title" className="mt-3 font-display text-4xl text-petrol sm:text-5xl" data-id="element-108" data-mp="ty324xpg7anu">
              Garantía de {guarantee.days} días
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-109" data-mp="yrp4nx1wdy5x">{guarantee.text}</p>
            <p className="mt-5 border-l-2 border-terra pl-4 text-left font-display text-xl italic text-terra-deep" data-id="element-110" data-mp="12t0spy54ibc0">
              {guarantee.highlight}
            </p>
          </div>
        </div>
      </div>
    </section>;
}